module.exports = __webpack_public_path__ + "images/ligier_smallb232e672b106a5e223428cbe26a3558f.png";